import request from '@/utils/request'
const preFixUrl = '/health/BackArticle'
// 文章相关接口
/**
 * 文章列表
 * @param {*} data
 * @returns
 */
export const getList = data => {
  return request({
    url: `${preFixUrl}/getArticleList`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}
/**
 * 查询文章详情
 * @param {*} data
 * @returns
 */
export const getArticleDetail = data => {
  return request({
    url: `/health/article/getDetail`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    },
    data
  })
}


// 文章相关接口
/**
 * 文章详情
 * @param {*} articleId
 * @returns
 */
export const articleDetail = articleId => {
  return request({
    url: `/gmjkylw_web/article/details/${articleId}`,
    method: 'get',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}

// 文章相关接口
/**
 * 文章-类型
 * @param {*}
 * @returns
 */
export const queryCategory = () => {
  return request({
    url: `${preFixUrl}/getArticleType`,
    method: 'post',
    headers: {
      ['Content-Type']: 'application/json'
    }
  })
}
